import store from 'redux/store';
import { s3Upload } from 'redux/actions/s3.action';
import config from 'config';
import S3 from 'aws-sdk/clients/s3';
import AWS from 'aws-sdk';

class UploadImageAdapterPlugin {
  constructor(loader) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file.then(file => 
      new Promise((resolve, reject) => {
        // Trực tiếp upload file 
        const state = store.getState();
        const { AccessKeyId, SecretKey, SessionToken } = state.user.credentials;
        const folder = 'bounty/images';

        const s3 = new S3({
          apiVersion: '2006-03-01',
          params: { Bucket: config.s3.BUCKET },
          signatureVersion: 'v4',
          region: config.s3.REGION,
          credentials: new AWS.Credentials(AccessKeyId, SecretKey, SessionToken),
        });
        
        const key = `${folder}/${Date.now()}.${file.type.split('/')[1]}`;

        s3.putObject(
          {
            Bucket: config.s3.BUCKET,
            Key: key,
            Body: file,
            ACL: 'public-read',
            ContentType: file.type,
          },
          (err, data) => {
            if (err) {
              console.log(err);
              reject(err);
              return;
            }
            const fileUrl = `${config.s3.URL}${config.s3.BUCKET}/${key}`;
            resolve({ default: fileUrl });
          }
        );
      })
    );
  }
}

export default UploadImageAdapterPlugin;
